import {FigmaFolder} from "@/includes/fig-parser/models/base/figma-folder";
import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";

export class FigmaFrame extends FigmaFolder {
  type = FIG_PARSED_FIELD_TYPES.FRAME;
  
  
}
